import classNames from "classnames";
import { useNavigate } from "react-router-dom";

import { getLinkedFirm } from "../../../sessionStorage/sessionStorage";
import { useGetTeamInvitationsQuery } from "../../../slices/UserSlice";

type Props = {
  activeTab: "users" | "invited-users" | "roles";
};

/**
 * Members · Invitations · Roles (owner 2026-10-25: Roles moved from the Settings tab row into Team).
 * Same look as the other settings toggles (GroupButtons); Invitations shows how many are waiting.
 */
export const TeamTabs = ({ activeTab }: Props) => {
  const navigate = useNavigate();
  const orgId = getLinkedFirm()?.orgId || "";
  const { data: invitations } = useGetTeamInvitationsQuery(orgId, {
    skip: !orgId,
  });
  const waiting = (invitations || []).filter(
    (invite) => invite.status !== "accepted",
  ).length;

  const tabs: {
    key: Props["activeTab"];
    label: string;
    to: string;
    count?: number;
  }[] = [
    { key: "users", label: "Members", to: "/settings/team/users" },
    {
      key: "invited-users",
      label: "Invitations",
      to: "/settings/team/invited-users",
      count: waiting,
    },
    { key: "roles", label: "Roles", to: "/settings/team/roles" },
  ];

  return (
    <div
      role={"tablist"}
      className={"flex rounded-lg border border-[#E4E9F2] p-1 font-medium"}>
      {tabs.map((tab) => (
        <button
          key={tab.key}
          type={"button"}
          role={"tab"}
          aria-selected={activeTab === tab.key}
          className={classNames(
            "flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm transition-all duration-300",
            activeTab === tab.key
              ? "bg-[#7A5AF81A] text-[#6938EF]"
              : "text-[#3F5266]",
          )}
          onClick={() => navigate(tab.to)}>
          {tab.label}
          {!!tab.count && (
            <span
              className={
                "min-w-[20px] rounded-full bg-[#6B4EFF] px-1.5 text-center text-[11px] font-bold leading-[18px] text-white"
              }>
              {tab.count}
            </span>
          )}
        </button>
      ))}
    </div>
  );
};
